<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="px-2 py-4">
        <custom-tabs v-model="optionTabs" :tab-items="tabItems" grow>
          <template v-slot:helpinfo="{ tab }">
            <help-info
              v-if="tab && tab.value && tab.text"
              :element-name="`${serviceName}-${componentName}-${tab.value}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="tab.text"
            />
          </template>

          <template v-slot:staticItems>
            <v-tab-item v-for="(item, i) in tabItems" :key="i">
              <v-row class="pa-md-2" no-gutters>
                <v-col
                  v-for="(v, index) in computedValue[item.value]"
                  class="pa-md-2"
                  :key="index"
                  cols="12"
                >
                  <v-row no-gutters>
                    <v-col
                      v-for="(component, j) in itemFields[item.value]"
                      :key="j"
                      class="pa-2"
                      cols="12"
                      lg="3"
                      md="6"
                      order="2"
                      order-md="1"
                    >
                      <div
                        class="rowinfo"
                        v-if="component.name === 'priceInput'"
                      >
                        <price-input
                          v-model.number="v[component.model]"
                          dense
                          :label="$t('productOptionEditor.fields.price')"
                        />
                        <help-info
                          v-if="index === 0"
                          :element-name="`${serviceName}-${componentName}-component-price`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('productOptionEditor.fields.price')"
                        />
                      </div>
                      <div class="rowinfo" v-else>
                        <component
                          :is="component.name"
                          v-model="v[component.model]"
                          v-bind="component.attrs"
                        />
                        <help-info
                          v-if="index === 0"
                          :element-name="`${serviceName}-${componentName}-component-${component.name}`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="component.attrs.label"
                        />
                      </div>
                    </v-col>

                    <v-btn
                      :icon="!$vuetify.breakpoint.mobile"
                      class="ma-2"
                      depressed
                      style="order: 1"
                      @click="deleteItem(item.value, index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                      <span class="d-md-none">{{
                        $t("productOptionEditor.actions.delete")
                      }}</span>
                    </v-btn>
                  </v-row>

                  <v-divider />
                </v-col>

                <v-col cols="12">
                  <v-card-actions>
                    <div class="rowinfo" style="width: 100%">
                      <v-btn
                        class="submit-btn ma-0 contentinfo"
                        depressed
                        @click="addObject(item.value)"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t("productOptionEditor.actions.add_location") }}
                        {{ item.text }}
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-object-add`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('productOptionEditor.actions.add_location')"
                      />
                    </div>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-tab-item>
          </template>
        </custom-tabs>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import priceInput from "@/view/pages/uiBeautifier/priceInput.vue";
import colorPicker from "@/view/pages/qrland/components/colorPicker.vue";

const types = {
  COUNT: "count",
  COLOR: "color",
  SIZE: "size",
  TYPE: "type",
  WEIGHT: "weight",
  COLOR_NAME: "color_name",
  INVENTORY: "inventory",
  MAX_ORDER: "max_order",
  PRICE: "price",
  DISCOUNT: "discount",
  GALLERY: "gallery",
};

export default {
  name: "productOptionEditor",
  components: {
    priceInput,
    colorPicker,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "product-option-editor",
      optionTabs: 0,
    };
  },
  computed: {
    tabItems() {
      return [
        {
          text: this.$t("productOptionEditor.tabs.color"),
          icon: "",
          value: "color",
        },
        {
          text: this.$t("productOptionEditor.tabs.size"),
          icon: "",
          value: "size",
        },
        {
          text: this.$t("productOptionEditor.tabs.count"),
          icon: "",
          value: "count",
        },
        {
          text: this.$t("productOptionEditor.tabs.weight"),
          icon: "",
          value: "weight",
        },
        {
          text: this.$t("productOptionEditor.tabs.type"),
          icon: "",
          value: "type",
        },
      ];
    },
    itemFields() {
      return {
        count: [
          {
            name: "VTextField",
            model: types.COUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.count"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.MAX_ORDER,
            attrs: {
              label: this.$t("productOptionEditor.fields.max_order"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "priceInput",
            model: types.PRICE,
            attrs: {
              label: this.$t("productOptionEditor.fields.price"),
              type: "number",
              outlined: true,
              dense: true,
            },
          },
          {
            name: "VTextField",
            model: types.DISCOUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.discount"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              appendIcon: "mdi-percent",
            },
          },
        ],
        color: [
          {
            name: "colorPicker",
            model: types.COLOR,
            attrs: {
              label: this.$t("productOptionEditor.fields.color"),
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              show: false,
            },
          },
          {
            name: "VTextField",
            model: types.COLOR_NAME,
            attrs: {
              label: this.$t("productOptionEditor.fields.color_name"),
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.INVENTORY,
            attrs: {
              label: this.$t("productOptionEditor.fields.inventory"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.MAX_ORDER,
            attrs: {
              label: this.$t("productOptionEditor.fields.max_order"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "priceInput",
            model: types.PRICE,
            attrs: {
              label: this.$t("productOptionEditor.fields.price"),
              type: "number",
              outlined: true,
              dense: true,
            },
          },
          {
            name: "VTextField",
            model: types.DISCOUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.discount"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              appendIcon: "mdi-percent",
            },
          },
        ],
        size: [
          {
            name: "VTextField",
            model: types.SIZE,
            attrs: {
              label: this.$t("productOptionEditor.fields.size"),
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.INVENTORY,
            attrs: {
              label: this.$t("productOptionEditor.fields.inventory"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.MAX_ORDER,
            attrs: {
              label: this.$t("productOptionEditor.fields.max_order"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "priceInput",
            model: types.PRICE,
            attrs: {
              label: this.$t("productOptionEditor.fields.price"),
              type: "number",
              outlined: true,
              dense: true,
            },
          },
          {
            name: "VTextField",
            model: types.DISCOUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.discount"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              appendIcon: "mdi-percent",
            },
          },
        ],
        type: [
          {
            name: "VTextField",
            model: types.TYPE,
            attrs: {
              label: this.$t("productOptionEditor.fields.type"),
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.INVENTORY,
            attrs: {
              label: this.$t("productOptionEditor.fields.inventory"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.MAX_ORDER,
            attrs: {
              label: this.$t("productOptionEditor.fields.max_order"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "priceInput",
            model: types.PRICE,
            attrs: {
              label: this.$t("productOptionEditor.fields.price"),
              type: "number",
              outlined: true,
              dense: true,
            },
          },
          {
            name: "VTextField",
            model: types.DISCOUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.discount"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              appendIcon: "mdi-percent",
            },
          },
        ],
        weight: [
          {
            name: "VTextField",
            model: types.WEIGHT,
            attrs: {
              label: this.$t("productOptionEditor.fields.weight"),
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.INVENTORY,
            attrs: {
              label: this.$t("productOptionEditor.fields.inventory"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "VTextField",
            model: types.MAX_ORDER,
            attrs: {
              label: this.$t("productOptionEditor.fields.max_order"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
            },
          },
          {
            name: "priceInput",
            model: types.PRICE,
            attrs: {
              label: this.$t("productOptionEditor.fields.price"),
              type: "number",
              outlined: true,
              dense: true,
            },
          },
          {
            name: "VTextField",
            model: types.DISCOUNT,
            attrs: {
              label: this.$t("productOptionEditor.fields.discount"),
              type: "number",
              outlined: true,
              dense: true,
              clearable: true,
              clearIcon: "mdi-close-circle-outline",
              appendIcon: "mdi-percent",
            },
          },
        ],
      };
    },
    pricingItems() {
      return [
        { value: "color", text: this.$t("productOptionEditor.tabs.color") },
        { value: "size", text: this.$t("productOptionEditor.tabs.size") },
      ];
    },
    computedValue: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    createBaseObject(type) {
      return this.itemFields[type].reduce(
        (acc, cur) => ({ ...acc, [cur.model]: "" }),
        {}
      );
    },
    addObject(type) {
      const newArray = this.computedValue[type]
        ? [...this.computedValue[type], this.createBaseObject(type)]
        : [this.createBaseObject(type)];

      this.computedValue = {
        ...this.computedValue,
        [type]: newArray,
      };
    },
    deleteItem(type, index) {
      const newArray = [...this.computedValue[type]];
      newArray.splice(index, 1);

      this.computedValue = {
        ...this.computedValue,
        [type]: newArray,
      };
    },
  },
};
</script>

<style scoped></style>
